// Dependecies
import { createStore, createHook } from 'react-sweet-state';

// Helpers
import { loadFromLocalstorage } from '../helpers';

const initialState = {
  currentLocale: loadFromLocalstorage('currentLocale', 'es'),
  componentName: '',
};

const actions = {
  changeLocale:
    (currentLocale) =>
    ({ setState, getState }) => {
      const storage = JSON.parse(localStorage.leo);

      if (currentLocale !== getState().currentLocale) {
        localStorage.leo = JSON.stringify({ ...storage, currentLocale });
        setState({ currentLocale });
      }
    },
  setComponentName:
    (componentName) =>
    ({ setState }) => {
      setState({ componentName });
    },
};

const Store = createStore({
  initialState,
  actions,
  name: 'locale',
});

export default createHook(Store);
